import { connect } from 'react-redux';

import { review } from '../actions';
import { approvalStatuses as statuses } from '../constants';
import PendingReviews from './PendingReviews';

const mapDispatchToProps = (dispatch, { campaignId, changeRequestId }) => ({
  onGrant: approval =>
    dispatch(
      review(campaignId, changeRequestId, approval.id, statuses.granted),
    ),
  onDeny: approval =>
    dispatch(review(campaignId, changeRequestId, approval.id, statuses.denied)),
});

export default connect(null, mapDispatchToProps)(PendingReviews);
